import { cn } from '@/lib/utils';

type IndexNumberProps = {
  value: number | string;
  variant?: 'inline' | 'display';
  className?: string;
};

export const IndexNumber = ({
  value,
  variant = 'inline',
  className,
}: IndexNumberProps) => {
  const formatted =
    typeof value === 'number' ? `#${String(value).padStart(2, '0')}` : value;

  if (variant === 'display') {
    return (
      <span
        className={cn(
          'text-display-xl text-brand-light select-none font-mono font-bold leading-none opacity-30',
          className
        )}
        aria-hidden="true"
      >
        {formatted}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'text-brand-light font-mono text-xs font-semibold tracking-tight',
        className
      )}
    >
      {formatted}
    </span>
  );
};
